import React from 'react';

// project-imports
import { formatDateWithSuffixV2 } from '../../utils';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { Link } from 'react-router-dom';
import { getGalleryFilters } from '../../utils/gallery-filter';

const PostYouTubeVideo = ({ data, classes, bgGray, index, onVideoToggle, isDedicatedPage, type, code, onOpenDrawer, activeFilter, onFilterChange }) => {

    // Local variables
    let published = data && data?.date ? data?.date : "";
    let publishedDate = formatDateWithSuffixV2(published) || "";
    const videoThumbnail = (data && data?.featuredImage) || "";
    let episodes = data?.cleanTitle?.split(":")?.[0] || "";
    // let episodesNumber = episodes?.split(".")?.[1] || "";
    let episodesNumber = episodes?.slice(1);

    // Getting Gallery Filter
    let galleryFilter = getGalleryFilters();

    const filtersItems = galleryFilter?.filter(i => i?.value === data?.category || "")

    // Constant function
    const handleVideoError = () => {
        console.log("Video failed to load.");
    };

    const getTag = () => {
        try {
            return isDedicatedPage ? "EP" : "EP";
        } catch (error) {

        }
    };

    return (
        <>
            <div className={`edu-blog blog-type-2 variation-2 radius-small ${classes ? classes : ''} ${bgGray === 'enable' ? 'bg-color-gray' : ''}`}>
                <div className="inner">
                    <div className="thumbnail">
                        <div className="video-area">
                            <div className="thumbnail video-popup-wrapper">
                                {/* working as aspected code start  */}
                                <video
                                    className="radius-small w-100"
                                    controls
                                    poster={
                                        videoThumbnail ||
                                        `${process.env.PUBLIC_URL}/images/course/video-bg/default-image.jpg`
                                    }
                                    onError={handleVideoError}
                                // height={"199px"}
                                >
                                    <source src={[data?.videoUrl]} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>

                                <button
                                    onClick={() => { onVideoToggle(data?.videoUrl); triggerFunction(window.location.href + GoogleAnalyticsEnum.LSA_SALESFORCE_TUTORIALS_VIDEO_PLAYED_BUTTON_CLICKED, data?.cleanTitle); }}
                                    className="video-play-btn position-to-top video-popup-activation"
                                >
                                    <span className="play-icon"></span>
                                </button>

                            </div>
                        </div>
                    </div>


                    <div className="content">
                        <div className="blog-date-status">
                            <span className="day">{getTag()}</span>
                            <span className="month">{episodesNumber}</span>
                        </div>
                        <div className="status-group status-style-5">
                            <div className="eduvibe-status status-05">
                                <i className="ri-eye-line"></i>{data?.viewdCount} views
                            </div>

                            <span className="eduvibe-status status-05"><i className="icon-time-line"></i> {publishedDate}</span>
                        </div>
                        <h5 className="title clickable" onClick={() => onOpenDrawer(data)}>
                            {data?.cleanTitle.trim()}
                        </h5>

                        {data?.tags && data?.tags?.length && (
                            <div className="rating eduvibe-course-rating-stars mt-0 text-start mt-4">
                                {(data?.tags || [])?.slice(0, 2).map((item, i) => (
                                    <span
                                        class="fs-5 badge text-success rounded-pill bg-success bg-opacity-25 text-capitalize mx-1"
                                        key={i}
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>
                        )}
                        {activeFilter === "all" &&
                            <div className="card-bottom">
                                <div className="read-more-btn">
                                    {(filtersItems || [])?.map((filter) => (
                                        <Link className="btn-transparent color-primary" onClick={() => onFilterChange(filter)} >
                                            {filter?.label}<i className="icon-arrow-right-line-right"></i>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default PostYouTubeVideo;